export default "__VITE_ASSET__BXGqoNBD__$_?url__"